export const formStructure = [[{
  name: 'nomeOperacao',
  label: 'Nome da Operação',
  placeholder: 'Digite o nome da operação',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  required: true,
  maxLength: 255,
  validation: {
    required: 'Nome da operação é obrigatório'
  }
}, {
  name: 'tipoDaOperacao',
  label: 'Tipo da Operação',
  placeholder: 'Digite o tipo da operação',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  required: true,
  maxLength: 100,
  validation: {
    required: 'Tipo da operação é obrigatório'
  }
}], [{
  name: 'situacao',
  label: 'Situação',
  component: 'SearchSelect',
  placeholder: 'Selecione a situação',
  minSearchLength: 0,
  colProps: {
    md: 4
  },
  options: [{
    value: 'Ativo',
    label: 'Ativo'
  }, {
    value: 'Inativo',
    label: 'Inativo'
  }]
}, {
  name: 'diasRecorrencia',
  label: 'Dias de Recorrência',
  placeholder: 'Ex: 7',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 4
  },
  min: '0'
}, {
  name: 'recorrenciaLigada',
  label: 'Ativar recorrência',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 4
  }
}], [{
  name: 'freetime',
  label: 'Freetime',
  placeholder: 'Digite o freetime',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 12
  },
  min: '0'
}], [{
  name: 'valorIndividualPallet',
  label: 'Valor Individual do Pallet',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}, {
  name: 'valorEtiquetas',
  label: 'Valor das Etiquetas',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}, {
  name: 'valorArmazenagem',
  label: 'Valor da Armazenagem',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}], [{
  name: 'gerarCobranca',
  label: 'Gerar Cobrança',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 'auto'
  }
}], [{
  name: 'observacao',
  label: 'Observações',
  placeholder: 'Digite observações adicionais',
  component: 'FormField',
  type: 'textarea',
  colProps: {
    md: 12
  },
  rows: 4 // Observacao é text no banco, sem limite específico

}]];
export const formSections = initialValues => [{
  title: `Detalhes da Operação ${initialValues.nomeOperacao || ''}`,
  rows: [0, 1] // Renderiza as linhas 0 e 1 da formStructure

}, {
  title: 'Configurações Operacionais',
  rows: [2] // Renderiza a linha 2 (freetime)

}, {
  title: 'Valores',
  rows: [3] // Renderiza a linha 3 (valores monetários)

}, {
  title: 'Configurações',
  rows: [4] // Renderiza a linha 4 (gerar cobrança)

}, {
  title: 'Informações Adicionais',
  rows: [5] // Renderiza a linha 5 (observações)

}]; // Função de validação do formulário

export const validateForm = values => {
  const errors = {}; // Validação do Nome da Operação

  if (!values.nomeOperacao || values.nomeOperacao.trim().length === 0) {
    errors.nomeOperacao = 'Nome da operação é obrigatório';
  } // Validação do Tipo da Operação


  if (!values.tipoDaOperacao || values.tipoDaOperacao.trim().length === 0) {
    errors.tipoDaOperacao = 'Tipo da operação é obrigatório';
  } // Validação dos dias de recorrência


  if (values.diasRecorrencia !== undefined && values.diasRecorrencia !== '') {
    const diasRecorrencia = parseInt(values.diasRecorrencia);

    if (isNaN(diasRecorrencia)) {
      errors.diasRecorrencia = 'Dias de recorrência deve ser um número inteiro válido';
    } else if (diasRecorrencia < 0) {
      errors.diasRecorrencia = 'Dias de recorrência deve ser positivo';
    }
  } // Validações monetárias para campos decimal(10,2)


  if (values.valorIndividualPallet !== undefined && values.valorIndividualPallet !== '') {
    const valorPallet = parseFloat(values.valorIndividualPallet);

    if (isNaN(valorPallet)) {
      errors.valorIndividualPallet = 'Valor individual do pallet deve ser um número válido';
    } else if (valorPallet < 0) {
      errors.valorIndividualPallet = 'Valor individual do pallet deve ser positivo';
    } else if (valorPallet > 99999999.99) {
      errors.valorIndividualPallet = 'Valor individual do pallet não pode ser maior que 99.999.999,99';
    }
  }

  if (values.valorEtiquetas !== undefined && values.valorEtiquetas !== '') {
    const valorEtiquetas = parseFloat(values.valorEtiquetas);

    if (isNaN(valorEtiquetas)) {
      errors.valorEtiquetas = 'Valor das etiquetas deve ser um número válido';
    } else if (valorEtiquetas < 0) {
      errors.valorEtiquetas = 'Valor das etiquetas deve ser positivo';
    } else if (valorEtiquetas > 99999999.99) {
      errors.valorEtiquetas = 'Valor das etiquetas não pode ser maior que 99.999.999,99';
    }
  }

  if (values.valorArmazenagem !== undefined && values.valorArmazenagem !== '') {
    const valorArmazenagem = parseFloat(values.valorArmazenagem);

    if (isNaN(valorArmazenagem)) {
      errors.valorArmazenagem = 'Valor da armazenagem deve ser um número válido';
    } else if (valorArmazenagem < 0) {
      errors.valorArmazenagem = 'Valor da armazenagem deve ser positivo';
    } else if (valorArmazenagem > 99999999.99) {
      errors.valorArmazenagem = 'Valor da armazenagem não pode ser maior que 99.999.999,99';
    }
  }

  return errors;
};
